import type { RootState } from '~publish/legacy/store'

export const selectShowRemindersConfirmation = (state: RootState): boolean =>
  state?.coachmarks?.showRemindersConfirmation

export const selectHasViewedRemindersConfirmation = (
  state: RootState,
): boolean => state?.coachmarks?.remindersConfirmationViewed
